import { showElem, stopElemAnim, addCloseElemAnim, hideElem } from './utils';
import { timeout } from './utils';

const dropdownHandler = (btn, dropdown, overlay) => {
  btn.addEventListener('mouseenter', () => {
    clearTimeout(timeout.id);

    stopElemAnim(overlay);
    stopElemAnim(dropdown);

    showElem(overlay);
    showElem(dropdown);
  });

  btn.addEventListener('mouseleave', (e) => {
    hideElem(e.target.querySelector('[data-dropdown-elem="dropdown"]'));
    addCloseElemAnim(overlay);
    addCloseElemAnim(dropdown);

    timeout.id = setTimeout(() => {
      hideElem(dropdown);
      hideElem(overlay);
    }, 300);
  });
};

export const initDropdown = () => {
  const overlay = document.querySelector('.overlay');
  const accountBtn = document.querySelector('.header-account');
  const dropdownAccount = document.querySelector('.account-dropdown');
  const subscribeBtn = document.querySelector('.header-subscribe');
  const dropdownSubscribe = document.querySelector('.subscribe-dropdown');

  if (accountBtn && dropdownAccount) {
    dropdownHandler(accountBtn, dropdownAccount, overlay);
  }

  if (subscribeBtn) {
    dropdownHandler(subscribeBtn, dropdownSubscribe, overlay);
  }
};
